import React from 'react';
import './ContributeSection.css';
import { IoRocketOutline, IoSchoolOutline, IoCheckmarkDoneOutline } from 'react-icons/io5';

const ContributeSection = () => {
  return (
    <section className="section contribute" id="contribute" aria-label="student contributor">
      <div className="container contribute-container">
        <div className="contribute-content">
          <p className="section-subtitle">Student Contributor</p>
          <h2 className="h2 section-title">
            🚀 Become a Student Contributor at <span className="span">SemGuru</span>
          </h2>

          <p className="section-text">
            Want to make a real impact in your university while gaining valuable experience?
            We're expanding SemGuru(VinTogether) to more universities and are looking for passionate students to help us build high-quality academic resources for their campus.
          </p>

          <div className="contribute-card">
            <p className="contribute-card-heading">What you'll help build</p>
            <ul className="contribute-list">
              <li>
                <IoRocketOutline aria-hidden="true" />
                Organize notes, previous year papers, study materials, and semester-specific content.
              </li>
              <li>
                <IoSchoolOutline aria-hidden="true" />
                Support your campus with resources that benefit thousands of students.
              </li>
              <li>
                <IoCheckmarkDoneOutline aria-hidden="true" />
                Gain real experience while helping build a community-led academic platform.
              </li>
            </ul>
          </div>

          <div className="contribute-benefits">
            <p className="contribute-benefits-title">What you'll get</p>
            <ul>
              <li>Official Internship Certificate</li>
              <li>Goodies during the internship</li>
              <li>Recognition as a founding contributor for your university</li>
              <li>🤖 Early access to our upcoming AI-powered learning and skill development platform</li>
              <li>📚 Academic guidance and mentorship from our team</li>
            </ul>
          </div>

          <div className="contribute-actions">
            <a
              href="https://docs.google.com/presentation/d/1JB2kFpwYwPrs4OvLn-TT0kiL7LeH2q8f/edit?usp=sharing&ouid=114576008760869341921&rtpof=true&sd=true"
              className="btn contribute-btn"
              target="_blank"
              rel="noreferrer"
            >
              Learn More
            </a>
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSejT-uVnXIN_eFl_6-Ni0tzwTK0cO1f4ycZALgBw06FOzB77w/viewform"
              className="btn contribute-btn secondary"
              target="_blank"
              rel="noreferrer"
            >
              Apply Here
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContributeSection;
